import { render, staticRenderFns } from "./Soil.vue?vue&type=template&id=3a185b8e&scoped=true&"
import script from "./Soil.vue?vue&type=script&lang=js&"
export * from "./Soil.vue?vue&type=script&lang=js&"
import style0 from "./Soil.vue?vue&type=style&index=0&id=3a185b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a185b8e",
  null
  
)

export default component.exports